import {css} from "styled-components";

export const ReactourStyle = css`
  /* stylelint-disable-next-line selector-id-pattern */
  #___reactour {
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    
    p {
      padding: 6px 0;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
`;
